/** @jsx jsx */
import { Box, Card, Flex, Grid, Heading, jsx } from "theme-ui";
import React, { PropsWithChildren } from "react";
import { BuilderBlocks } from "@builder.io/react";
import { BuilderBlock } from "@builder.io/react/dist/types/src/components/builder-block.component";

export type ContentCardProps = {
  heading: string;
  builderBlock: BuilderBlock;
} & PropsWithChildren ;
export const ContentCard: React.FC<ContentCardProps> = ({
  heading,
  children,
  builderBlock,
}) => {
  //console.log("blah", children);
  return (
    <Card sx={{ height: "100%", overflow: "hidden" }}>
      <Grid
        gap={0}
        columns={1}
        sx={{ height: "100%", gridTemplateRows: heading ? "64px 1fr" : "1fr" }}
      >
        {heading && (
          <Flex
            variant={"cards.primary.titleBar"}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              //minHeight: "64px",
            }}
          >
            <Heading variant="cardHeading" as="h2">
              {heading}
            </Heading>
          </Flex>
        )}
        <Flex sx={{ width: "100%", height:"100%" }} id="children">
          <BuilderBlocks
            sx={{ display: "inline", width: "100%", height:"100%" }}
            child
            parentElementId={builderBlock?.id}
            dataPath="this.children"
            blocks={children}
          />
        </Flex>
      </Grid>
    </Card>
  );
};

export default ContentCard;
